import React from "react";
import Sidebar from "../components/Sidebar";

const Reports: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">รายงาน</h1>
          <p className="text-gray-600 mb-6">สร้างและดูรายงานต่างๆ</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานยอดขาย</h3>
              <p className="text-sm text-gray-600 mb-4">สรุปยอดขายรายวัน/รายเดือน</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานคำสั่งซื้อ</h3>
              <p className="text-sm text-gray-600 mb-4">รายละเอียดคำสั่งซื้อทั้งหมด</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานสินค้า</h3>
              <p className="text-sm text-gray-600 mb-4">สถิติและการขายสินค้า</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานลูกค้า</h3>
              <p className="text-sm text-gray-600 mb-4">ข้อมูลและพฤติกรรมลูกค้า</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานการชำระเงิน</h3>
              <p className="text-sm text-gray-600 mb-4">สถิติการชำระเงิน PromptPay</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">รายงานสต็อก</h3>
              <p className="text-sm text-gray-600 mb-4">สถานะสต็อกสินค้า</p>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors">
                สร้างรายงาน
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
